module.exports = __webpack_public_path__ + "img/approval.b6c42588.png";